export const SUCCESS = {
  DARK: '#00766A',
  DEFAULT: '#00897B',
  LIGHT: '#B9E6CD',
  LIGHTER: '#E0F2E3',
} as const;
